export default {
    namespaced: true,
    state: {
        categories: [],
        category: null,
        icons: [
            {
                icon: 'cat1-icon'
            },
            {
                icon: 'cat2-icon'
            },
            {
                icon: 'cat3-icon'
            },
            {
                icon: 'cat4-icon'
            }
        ]
    },
    mutations: {
        setCategories: (state, categories) => {
            state.categories = categories;
        },

        setCategory: (state, category) => {
            state.category = category;
        },
    },
    actions: {
        getCategories(context) {
            return this.$axios.get('/categories', {
                    params: {
                        type: 'toll'
                    }
                })
                .then(response => {
                    if(response.data.categories) {
                        context.commit('setCategories', response.data.categories);
                    }

                    return response;
                });
        },

        getCategory(context, category_id) {
            return this.$axios.get('/category/' + category_id, {
                    params: {
                        type: 'toll'
                    }
                })
                .then(response => {
                    if(response.data.category) {
                        context.commit('setCategory', response.data.category);
                    }

                    return response;
                });
        },
    },
    getters: {
        getCategories: (state) => {
            return state.categories;
        },

        getCategory: (state) => {
            return state.category;
        },
    }
}
